import { open_nav_folder_api_job_number_path, open_production_folder_api_job_number_path } from '../../routes'
import { isMac } from '../helpers/os_detection'

const SMB_HOST = 'local.effection.dk'
const SMB_FILES_PREFIX = `smb://${SMB_HOST}/Files`

function buildProductionFolderRange(orderNumber: string): string | null {
  const orderNo = parseInt(orderNumber, 10)
  if (isNaN(orderNo)) return null

  const base = Math.floor(orderNo / 1000) * 1000
  return `${base}-${base + 999}`
}

export function buildProductionFolderUrl(jobnumberId: number, orderNumber: string): string | null {
  if (!isMac()) return open_production_folder_api_job_number_path(jobnumberId)

  const range = buildProductionFolderRange(orderNumber)
  if (!range) return null

  return `${SMB_FILES_PREFIX}/Produktion/${range}/${orderNumber}`
}

export function buildNavFolderUrl(jobnumberId: number, pathFolder: string): string {
  if (!isMac()) return open_nav_folder_api_job_number_path(jobnumberId)

  return `${SMB_FILES_PREFIX}/Sagsmapper/${pathFolder}`
}
